import { useState, useEffect } from 'react';
import { CheckCircle2, Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { useUplogCredential, useUpsertUplogCredential, useTestUplogAuth } from '@/hooks/useUplog';

export function UplogCredentialForm() {
  const { data: existing, isLoading } = useUplogCredential();
  const { mutate: upsert, isPending: saving } = useUpsertUplogCredential();
  const { mutate: testAuth, isPending: testing } = useTestUplogAuth();

  const [baseUrl, setBaseUrl] = useState('');
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  useEffect(() => {
    if (existing) {
      setBaseUrl(existing.baseUrl);
      setUsername(existing.username);
    }
  }, [existing]);

  function handleSave() {
    if (!baseUrl.trim() || !username.trim() || !password.trim()) return;
    upsert({ baseUrl: baseUrl.trim(), username: username.trim(), password });
  }

  if (isLoading) return null;

  return (
    <Card>
      <CardHeader>
        <CardTitle>API UpLog</CardTitle>
        <CardDescription>
          Credenciais para integração com o sistema UpLog via WordPress JWT.
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        {existing && (
          <div className="flex items-center gap-2 rounded-md bg-green-50 px-3 py-2 text-sm text-green-700 dark:bg-green-900/20 dark:text-green-400">
            <CheckCircle2 className="h-4 w-4 shrink-0" />
            Credenciais configuradas · última atualização{' '}
            {new Date(existing.updatedAt).toLocaleDateString('pt-BR')}
          </div>
        )}

        <div className="space-y-2">
          <Label htmlFor="fin-url">URL base *</Label>
          <Input
            id="fin-url"
            placeholder="https://sistema.escola.com.br"
            value={baseUrl}
            onChange={(e) => setBaseUrl(e.target.value)}
          />
        </div>

        <div className="space-y-2">
          <Label htmlFor="fin-user">Usuário *</Label>
          <Input
            id="fin-user"
            placeholder="admin"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />
        </div>

        <div className="space-y-2">
          <Label htmlFor="fin-pass">
            Senha *{existing && <span className="ml-1 text-xs text-muted-foreground font-normal">(deixe em branco para manter)</span>}
          </Label>
          <Input
            id="fin-pass"
            type="password"
            placeholder={existing ? '••••••••' : 'senha'}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>

        <div className="flex gap-2 pt-1">
          <Button onClick={handleSave} disabled={saving || !baseUrl || !username || (!existing && !password)}>
            {saving && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
            Salvar
          </Button>
          {existing && (
            <Button variant="outline" onClick={() => testAuth()} disabled={testing}>
              {testing && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
              Testar conexão
            </Button>
          )}
        </div>
      </CardContent>
    </Card>
  );
}
